export default {
  isLoading: false,
  isModalWizardLoading: false,
  // Listas que seran alimentadas por endPoint
  centrosList: [],
  isOpenModalEditWeek: false,
  isOpenModalConflictWeek: false,
  isOpenModalDeleteOpening: false,
  idOpeningToDelete: null,
  appointment: {},
  appointmentEditWeek: {},
  feriadosAdministrativos: [],
  isDownloadExcel: false,
  isModalNameAndConflictOpen: false,
  centerId: null,
  centerConfig: {
    minWorkDay: null,
    maxWorkDay: null,
    minSatWork: null,
    maxSatWork: null,
    minSunWork: null,
    maxSunWork: null,
    canOverBookCiel: true,
    maxOverBookCiel: null,
    canOverBookOcupational: true,
    maxOverBookOcupational: null,
    canOverBookPreocupational: true,
    maxOverBookPreocupational: null,
    listDaysWorking: [],
    listExamPools: [],
    listExams: [],
    listCiel: [],
  },
  validationOpening: {
    quotes: 0,
    openValidation: false,
    message: null,
  },
  configList: [],
  // Fin Listas que seran alimentadas por endPoint
  steps: {
    isNewApertura: false,
    stepOne: true, // configuracion de apertura
    stepTwo: false, // Ingreso baterias/prestaciones / ciel
    stepThree: false, // Matriz de cupos
    stepSuccess: false, // termino de ingreso apertura
  },
  isBackStep: false,
  isPopupWizardOpen: false,
  configSchedulerWizard: {
    startDayHour: 9,
    endDayHour: 17,
    cellDuration: 30,
  },
  listaAppointments: null,
  weekAppointments: null,
  // lo que se va almacenando en el wizard
  Opening: {
    Id: 0,
    IdConfig: null,
    IdCentro: null,
    isNewConfig: true,
    NameOpening: null,
    startDate: null,
    endDate: null,
    workDays: [],
    startWorkDay: null,
    endWorkDay: null,
    weekWorking: true,
    satWorkstart: null,
    satWorkEnd: null,
    sunWorkStart: null,
    sunWorkEnd: null,
    satWorking: false,
    sunWorking: false,
    moduleTime: null,
    priorityData: [],
    data: [],
    ExamPools: [], // baterias
    Exams: [],
    Ciel: [],
  },
  modulesConfig: [],
  listQuotes: [],

};
